<template>
  <div class="module-header">
		<div class="module-title">
			<img class="module-title-icon" src="@/assets/data-center/title-icon.png">
			<span>{{ title }}</span>
		</div>
		<img class="module-header-line" :src="require(`@/assets/data-center/${lineIcon}.png`)">
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		lineIcon: {
			type: String,
			default: 'title-line-1'
		}
	}
}
</script>

<style lang="scss" scoped>
.module-header {
	.module-title {
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		.module-title-icon {
			width: 14px;
			height: 30px;
			margin-right: 12px;
		}
	}
	.module-header-line {
		width: 100%;
	}
}
</style>
